module.exports = __webpack_public_path__ + "img/funding.e68e88ed.png";